// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div.user>div>div>.agent-icon-img{display:none}.agent-icon-img{position:inherit;height:100%;background-color:#fff;border-radius:50%;z-index:0;width:100%;-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
